export const pillars = ['Assessment', 'Progression', 'Return-to-Sport', 'Prevention'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Shoulder Blueprint',
  desc: 'Understand how shoulder mechanics work clearly and step by step, so you can assess, rehabilitate and return athletes to pressing movements with confidence — even if you have never managed shoulder injuries before.'
}, {
  n: 2,
  emoji: '📗',
  title: 'The Knee Fortress',
  desc: 'Learn to manage ACL, MCL and patellar tendon injuries with progressive load protocols and avoid the most common mistakes professionals make when prescribing knee rehabilitation, even if you have never managed complex knee injuries.'
}, {
  n: 3,
  emoji: '📙',
  title: 'The Ankle & Foot Command',
  desc: 'Incorporate the complete ankle sprain protocols, proprioceptive retraining hierarchy and return-to-running criteria that actually appear in elite sports settings, so you can manage ankle injuries in real situations from the first session.'
}, {
  n: 4,
  emoji: '📕',
  title: 'The Spine & Core Shield',
  desc: "Follow an organized framework to manage lower back pain, disc herniation and core dysfunction with clear progression criteria to advance without getting lost, measuring your client's readiness with concrete assessment points."
}, {
  n: 5,
  emoji: '📓',
  title: 'The Hip & Pelvis Engine',
  desc: 'By the end of this volume you will understand hip mobility, glute activation and pelvic stability so completely that you can build protocols for any hip-related athlete without overthinking it.'
}, {
  n: 6,
  emoji: '📔',
  title: 'The Elbow & Wrist Recovery',
  desc: 'Make real clinical decisions, manage tennis elbow and carpal tunnel cases, and have your first complete recovery protocol in place without freezing or second-guessing your progressions.'
}];
export const volumeIncludes = ['Visual step-by-step protocols', 'Assessment criteria + translation', 'Progression checkpoints', 'Real return-to-sport examples', 'Daily practice checklists', 'Printable tracking sheets', 'Designed for beginner and advanced levels', 'Ready to apply from today'];
export const bonuses = [{
  n: '01',
  title: 'The M.A.P.A. Mobility Flow™',
  desc: 'A pack of complete mobility protocols ready to use for activating all joints, building movement patterns, applying functional progressions and assessing readiness. Perfect for studying on your phone, printing and practicing step by step.',
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/jcM4Sy3jHKjJnQqHbzmMWy/BONO_1.png'
}, {
  n: '02',
  title: 'The Zero-Equipment Home Guide™ — RECOVER FROM ZERO',
  desc: 'A quick and simple guide to managing complete rehabilitation at home using only bodyweight, chairs, towels and basic household items, recognizing when to progress and building your first at-home protocol without feeling overwhelmed.',
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/rq2ADnUoTcwu5Gk8ueQhk9/BONO_2.png'
}, {
  n: '03',
  title: 'The Load Master Protocol™ (LOAD PROGRESSION SYSTEM)',
  desc: 'A selection of complete gym-based protocols to start applying machine work, dumbbells, barbells and cables with clear load progression criteria. Includes assessment points, tracking and practical usage in real settings.',
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/91GcBvsKtwc64nUaZ8miF8/BONO3.png'
}, {
  n: '04',
  title: 'The A.R.M.A. Preventive Shield™',
  desc: "A permanent maintenance system to ensure the body doesn't fail again. A.R.M.A. (Assessment, Resilience, Maintenance, Action). It includes a monthly joint health checklist and a preventive strengthening plan (2 days a week).",
  price: '$39',
  cover: 'https://cdn.magicpatterns.com/uploads/6S2EVijbrjy525pgSnJjrc/BONO4.png'
}, {
  n: '05',
  title: 'The Performance Warm-up Matrix™',
  desc: 'Dynamic warm-up protocols adapted to lifestyle. Specific routines for runners, CrossFitters and tennis players, plus a special protocol for office workers who sit for 8 hours and need to reactivate their posterior chain.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/gFWxeUmU5NdoPeX6LBrpUs/BOONO5.png'
}];
